import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {TechSupportForm} from '../../common-main/components/tech-support/tech-support-form';

@Injectable()
export class TechSupportService {

  constructor(private http: HttpClient) {
  }

  getAdminData() {
    return this.http.get<any>('api/s/tech-support/admin/getData');
  }

  saveAdminData(techData) {
    return this.http.post<any>('api/tech-support/admin/saveData', techData);
  }

  getModeratorFAQById(id: number) {
    return this.http.get<any>('api/tech-support/moderator/getFAQ/' + id);
  }

  saveModeratorFAQ(faq) {
    return this.http.post<any>('api/tech-support/moderator/saveFAQ', faq);
  }

  getModeratorFAQ(page: any) {
    return this.http.post<any>('api/s/tech-support/moderator/getFAQ', page);
  }

  deleteFAQ(id: number) {
    return this.http.delete<any>('api/tech-support/moderator/deleteFAQ/' + id);
  }

  iLikeIt(id: number) {
    return this.http.get<any>('api/s/tech-support/like/' + id);
  }

  sendMessage(msg: TechSupportForm) {
    return this.http.post<any>('api/s/tech-support/message', msg);
  }

  getTechSupportModerators() {
    return this.http.get<any>('api/tech-support/admin/getTechSupportModerators');
  }

  saveTechSupportModerators(moderators) {
    return this.http.post<any>('api/tech-support/admin/saveTechSupportModerators', moderators);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/services/tech-support.service.ts